import { makeAutoObservable } from "mobx";
import { SubtitleItem } from "@/shared/types/player";

export class PlayerStore {
    selectedSub: SubtitleItem | undefined;

    constructor() {
        makeAutoObservable(this);
    }

    setSelectSub(sub: SubtitleItem) {
        console.log("setSelectSub", sub);
        this.selectedSub = sub;
    }
}
